<template>
  <div class="template-A">
    <div class="chunk-list">
      <div
        class="chunk-item"
        v-for="item in data"
        :key="item.id"
        @click="handleClick(item)"
      >
        <img :src="item.icon" alt="" v-if="item.icon" />
        <p v-html="item.title" v-if="item.title"></p>
      </div>
    </div>
  </div>
</template>

<script>
import os from '@utils/os'
export default {
  props: {
    data: {
      type: Array
    }
  },
  data () {
    return {}
  },
  methods: {
    handleClick (item) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          let targetUrl = item.content_url
          // 判断是否需要追加 pf 和 uid 参数（CCAapp 跳转场景）
          const isDocbookUrl = /m\.docbook\.com\.cn|docbook\.com\.cn/.test(targetUrl)
          if (isDocbookUrl && this.$route.query.uid && this.$route.query.platform) {
            targetUrl = os.appendQuery(targetUrl, {
              platform: this.$route.query.platform,
              uid: this.$route.query.uid
            })
          }
          if (os.isPC()) {
            if (os.isInWechatMiniProgram()) {
              window.location.href = targetUrl
            } else {
              window.open(targetUrl)
            }
          } else {
            window.location.href = targetUrl
          }
        }
      } else {
        // window.location.href = `detail?id=${item.id}`
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chunk-list {
  width: 100%;
  height: auto;
  padding-bottom: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.chunk-item {
  width: 33.33333%;
  height: 5.34rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  img {
    display: block;
    width: 3.12rem;
    height: 3.12rem;
    margin: 0 auto;
    margin-top: 0.64rem;
  }
  p {
    width: 100%;
    text-align: center;
    font-size: 15px;
    margin-top: 0.4rem;
    color: white;
  }
}
</style>
